module.exports = __webpack_public_path__ + "static/media/zhengkai.546a722e.png";